<script setup>
import { post } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import { useMetaStore } from '@/stores'
import { QuillEditor } from '@vueup/vue-quill'
import { reactive } from 'vue'
const props=defineProps(['wkey']),meta=reactive({data:{wkey:props.wkey}}),metaStore=useMetaStore()
,mod=async()=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/resetconfs',[meta.data])
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
},save=()=>{
  meta.poptype=null
  metaStore.pop({ison:true,callback:()=>meta.poptype='save'})
},search=async()=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/member/confs',{wkey:props.wkey})
  metaStore.blockLoading(false)
  if(res.data.length>0)meta.data=res.data[0]
  else meta.data={wkey:props.wkey}
}
search()
</script>
<template>
  <v-card flat class="admpricon">
    <v-card-title>{{ $t(props.wkey) }}</v-card-title>
    <v-card-text>
      <v-table style="border: 1px solid #e0e0e0;">
        <tbody>
          <tr>
            <th class="text-center" style="background-color: #eee;height: calc(100vh - 400px);width: 100px;">
              {{ $t('entercontent') }}
            </th>
            <td class="pa-2">
              <QuillEditor theme="snow" content-type="html" :content="meta.data.tval" @update:content="html=>meta.data.tval=html"/>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-spacer/>
        <v-col cols="2" class="pe-5">
          <v-btn block variant="elevated" class="me-6" :text="$t('refresh')" @click="search"/>
        </v-col>
        <v-col cols="2" class="pe-5">
          <v-btn block variant="elevated" color="primary" class="me-6" :text="$t('save')" @click="save"/>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
  <Teleport v-if="meta.poptype" to="#popbody">
    <ConfirmCard :ttl="$t(props.wkey)" :cont="metaStore.t('save_con')" @cancel="metaStore.pop({ison:false})" @confirm="mod"/>
  </Teleport>
</template>
<style>
.admpricon .ql-container{height: calc(100vh - 350px)}
</style>
